import Store from 'redux/store';
import { FETCH_BILL_PAYMENT_SERVICES, FETCH_BILL_PAYMENT_SERVICES_FAIL, FETCH_BILL_PAYMENT_SERVICES_SUCCESS  } from 'redux/Reducers/BillPaymentServices/BillPaymentServicesReducer'
import { cloudloyalty } from '../clients';

// eslint-disable-next-line default-param-last
const FetchBillPaymentServices = async (User, finallyCallback = () => {}, { vendorId }) => {
  Store.dispatch({ type: FETCH_BILL_PAYMENT_SERVICES, payload: { vendorId } });
  cloudloyalty(User).get(`/v1/billPayments/vendor/${vendorId}/service`).then((response) => {
    Store.dispatch({
      type: FETCH_BILL_PAYMENT_SERVICES_SUCCESS,
      payload: {
        vendorId,
        ...response,
        status: (typeof response?.response?.data === 'object' && Array.isArray(response?.response?.data)) ? response?.data[0]?.status : response?.data?.status ,
        statusCode: response?.status
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_BILL_PAYMENT_SERVICES_FAIL,
      payload: {
        vendorId,
        status: (typeof e?.response?.data === 'object' && Array.isArray(e?.response?.data)) ? e?.response?.data[0]?.status: e?.response?.data?.status,
        statusCode: e?.response?.status
      },
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchBillPaymentServices;
